export const MarketingConsent = `AI아크수학의 운영사, ㈜아이스크림미디어와 ㈜매쓰마스터는 AI 아크수학 서비스와 관련된 이벤트 및 혜택 안내 등을 목적으로 카카오 알림톡, 문자메시지(SMS)를 통해 마케팅 정보를 발송하고자 합니다.
마케팅 정보 활용에 동의하지 않으셔도 서비스 이용에는 영향이 없으며, 동의를 철회할 수 있습니다. 

회원가입, 주문배송 등 관련 안내를 위한 카카오 알림톡, 문자메시지 등은 마케팅 활용 동의와 관계없이 모든 회원에게 발송됩니다.

1. 수집 및 이용 목적
상품 및 서비스 안내, 할인 혜택(프로모션), 이벤트 행사 정보 제공

2. 수집항목
이름, 휴대폰번호, 이메일

3. 보유 및 이용기간
회원탈퇴 또는 고객 삭제요청시까지, 단 관련 법령에 따라 일정기간 동안 보존이 필요한 경우 해당 기간 동안 보관 후 파기

위의 개인정보 수집 및 마케팅 활용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 프로모션 및 이벤트 정보를 받을 수 없습니다.
`;